export default __webpack_public_path__ + "static/media/EM1780.34I-43299_-25920_0.ae953ff1.jpg";